export enum PAGE_MODES {
  MAP = 'map',
  LIST = 'list',
}